import React,{ useState, useContext } from 'react'
import { axios } from '../../axios'
import { UserContext } from '../../UserContext';
import { Link, useNavigate } from "react-router-dom";
import img_background from './bolsas-de-compra-coloridas.jpg';

// Espejo de theme-001 Admin/pages/login (port bloque 6, nov 2026): mismo
// fondo, tarjeta y textos; el 401 avisa con un mensaje legible en vez del
// AxiosError crudo. Diferencias a propósito: el form es estado local (sellers
// no tiene react-hook-form ni @package/hooks), y el link inferior es "Create
// account" (/create) porque sellers aún no tiene /recuperar (decisión pendiente).

const Login = props => {

	const navigate = useNavigate()
	const [data,setData] = useState({})
	const { setUser, setAuth } = useContext(UserContext);

	const _logan=(e)=>{
		e.preventDefault()
		axios.post('/api/login_seller',data).then(r=>{
			setUser(r.data.user)
			localStorage.setItem('access_token', r.data.access_token);
			axios.defaults.headers.common['Authorization'] = 'Bearer '+r.data.access_token
			setAuth(true)
			setData({})
			navigate('/')
		}).catch(r=>{
			if (r.response?.status === 401) {
				alert('The credentials do not match our database, please try again later')
			} else {
				alert(r.response?.data?.message ?? r.message ?? r) // red/throttle: no hay response
			}
		})
	}

	return (
		<div style={{backgroundImage:`url(${img_background})`, backgroundSize:'cover', backgroundPosition:'center', height:'100vh'}}>
			<div style={{display:'flex', justifyContent:'center', alignItems:'center',height:'100vh'}}>
				<div className="card center" style={{borderRadius:8, padding:20, width:400, boxShadow:'0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}>
					<div className="card-content">
						<span className="card-title">Sign In</span>
						<div className="row">
							<form onSubmit={_logan} className="col s12">
								<div className="row">
									<div className="input-field col s12">
										<i className="material-icons prefix">account_circle</i>
										<input onChange={(e)=>setData({...data,email:e.target.value})} value={data.email||''} id="icon_prefix" type="text" required/>
										<label htmlFor="icon_prefix">Email</label>
									</div>
									<div className="input-field col s12">
										<i className="material-icons prefix">lock</i>
										<input onChange={(e)=>setData({...data,password:e.target.value})} value={data.password||''} id="password" type="password" required/>
										<label htmlFor="password">Password</label>
									</div>
								</div>
								<button className="btn waves-effect waves-light black lighten-1" type="submit" name="action">Log In<i className="material-icons right">send</i></button>
							</form>
						</div>
					</div>
					<Link className='right' style={{fontSize:11, color:'red'}} to='/create/'>Create account</Link>
				</div>
			</div>
		</div>
		)
}
export default Login
